// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f4ca5fd","453":"036ba5e3","455":"92955114","977":"6005bec5"}[chunkId] + ".chunk.js";
};